import { observable } from 'mobx';
import _ from 'lodash';
import lqApi from '../api';

import { errorNotifiy } from '../core/error-helper';

export default class PackageStore {
  @observable barcode = null;
  @observable packageInfo = null;
  @observable packageTimer = null;
  @observable shopGroups = null;
  @observable benefitGroups = [];
  @observable historyGroups = [];
  @observable isOpenModal = false;
  @observable shopSeq = null;

  setPackageInfo = async (barcode) => {
    if (this.packageInfo) return;

    this.barcode = barcode || this.barcode;
    const packageBarcode = this.barcode;

    const packageInfo = await lqApi.getPackageInfo(packageBarcode);

    if (_.isEmpty(packageInfo)) {
      errorNotifiy('티켓을 찾을 수 없습니다.');
      return;
    }

    this.packageInfo = packageInfo;
  };

  setShopGroups = async (barcode) => {
    const shopGroups = await lqApi.getShopGroups(barcode);
    
    if (_.isEmpty(shopGroups)) {
      errorNotifiy();
      return;
    }

    this.shopGroups = shopGroups;
  };

  setBenefitGroups = async (barcode) => {
    const benefitGroups = await lqApi.getBenefitGroups(barcode);
    this.benefitGroups = benefitGroups;
  };

  setHistoryGroups = async (barcode) => {
    const historyGroups = await lqApi.getHistoryGroups(barcode);
    
    if (_.isEmpty(historyGroups)) {
      errorNotifiy();
      return;
    }

    this.historyGroups = historyGroups;
  };

  startTimerCount = () => {
    const time = this.packageInfo && this.packageInfo.time;
  
    if (!time || !time.timer || time.expired) return;
    if (this.packageTimer) return;

    const nowTime = () => {
      const nowTimeGroup = time.remainTime.split(':');
      const nowTimeCount = (nowTimeGroup[0] * 60 * 60) + (nowTimeGroup[1] * 60) + (nowTimeGroup[2] * 1); 

      return nowTimeCount;
    };

    let count = nowTime();

    const formatTime = (seconds) => {
      var h = Math.floor(seconds / 3600),
          m = Math.floor(seconds / 60) % 60,
          s = seconds % 60;
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      return h + ":" + m + ":" + s;
    };

    const timer = () => {
      count--;
      if (count < 0) return clearInterval(counter);
      this.packageTimer = formatTime(count);
    };
    
    let counter = setInterval(timer, 1000);
  };

  controlModal = (shopSeq, couponCode) => {
    if (!shopSeq) return;
    if (!couponCode) return;

    this.shopSeq = shopSeq;
    this.couponCode = couponCode;
    this.isOpenModal = true;
  };

  closeModal = () => {
    this.isOpenModal = false;
    this.shopSeq = null;
  };

  useCouponModal = async (count) => {
    const usingCoupon = await lqApi.usingCoupon(this.shopSeq, this.couponCode, count);

    if (_.isEmpty(usingCoupon)) {
      errorNotifiy();
      return;
    }

    this.setBenefitGroups(this.barcode);
    this.closeModal();
  };
}


// WEBPACK FOOTER //
// ./src/stores/PackageStore.js